<div class="flex-direction-column gap-5">
  @if (label) {
    <span class="campo-label">{{ label }}</span>
  }

  <div class="campo-telefone-container">
    <div class="campo-input-base campo-telefone-caixa" [class.campo-input-erro]="erro" [class.campo-telefone-desabilitado]="disabled">
      <button type="button" class="campo-telefone-pais" [disabled]="disabled" [attr.aria-expanded]="aberto()"
              [attr.aria-label]="'País: ' + paisSelecionado().nome" (click)="alternar()">
        <img class="campo-telefone-bandeira" [src]="bandeira(paisSelecionado())" alt="" />
        <span class="campo-telefone-codigo">{{ paisSelecionado().codigo }}</span>
      </button>
      <input
        #campoNumero
        class="campo-telefone-input"
        type="tel"
        inputmode="numeric"
        autocomplete="off"
        [placeholder]="placeholder"
        [disabled]="disabled"
        [value]="numeroExibicao()"
        (input)="aoDigitar($event)"
        (blur)="aoTocar()" />
    </div>

    @if (aberto()) {
      <div class="campo-telefone-painel" @subir>
        <div class="campo-telefone-busca">
          <img src="./assets/icones/redesign/inputs/icon-search-input.svg" alt="" class="campo-telefone-busca-icone" />
          <input
            #campoBuscaPais
            class="campo-telefone-busca-input"
            type="text"
            autocomplete="off"
            placeholder="Buscar por país ou código"
            [ngModel]="filtroPais()"
            (ngModelChange)="filtroPais.set($event)" />
        </div>

        <div class="campo-telefone-opcoes">
          @for (pais of paisesFiltrados(); track pais.iso) {
            <button type="button" class="campo-telefone-opcao" [class.campo-telefone-opcao-ativa]="pais.iso === paisSelecionado().iso"
                    (click)="selecionarPais(pais)">
              <img class="campo-telefone-bandeira" [src]="bandeira(pais)" alt="" loading="lazy" />
              <span class="campo-telefone-opcao-nome">{{ pais.nome }}</span>
              <span class="campo-telefone-opcao-codigo">{{ pais.codigo }}</span>
            </button>
          } @empty {
            <span class="campo-telefone-vazio">Nenhum país encontrado.</span>
          }
        </div>
      </div>
    }
  </div>

  @if (erro) {
    <span class="campo-erro-texto">{{ erro }}</span>
  }
</div>
